module.exports = __webpack_public_path__ + "static/media/relay_success_account_connected.6313d93f.png";